import { render, staticRenderFns } from "./ImageGallery.vue?vue&type=template&id=163cc9bd"
import script from "./ImageGallery.vue?vue&type=script&lang=js"
export * from "./ImageGallery.vue?vue&type=script&lang=js"
import style0 from "./ImageGallery.vue?vue&type=style&index=0&id=163cc9bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports